import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	trialInfo: {
		id: 'project-directory-onboarding-modal.trial-info',
		defaultMessage:
			'Free 30-day Premium plan trial. Cancel or downgrade anytime. By selecting “Get started” you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy</pp>.',
		description: 'Information about the free 30-day Premium plan trial and agreement terms',
	},
});
